export const SET_DIGITAL_SECTION_DATA = "SET_DIGITAL_SECTION_DATA";

export const setDigitalSectionData = (data) => ({
  type: SET_DIGITAL_SECTION_DATA,
  payload: data,
});
